import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DefectsTable from "@/components/tables/defects/DefectsTable.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DefectTableView',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefectsTable))
}
}

})